import React from "react";
import { Box, Typography } from "@mui/material";

interface MyCafeteriaStatementTitleProps {
  label: string;
  currentYear?: number;
}

export const MyCafeteriaStatementTitle: React.FC<
  MyCafeteriaStatementTitleProps
> = ({ label, currentYear }) => {
  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      paddingTop="70px"
      paddingBottom="80px"
    >
      <Typography variant="h5">
        {label} {currentYear}
      </Typography>
    </Box>
  );
};

export default MyCafeteriaStatementTitle;
